import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import CenterFocusStrongIcon from '@material-ui/icons/CenterFocusStrong';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import PropTypes from 'prop-types';
import React from 'react';
import RemoveDialog from './RemoveDialog';
import SettingsDialog from './SettingDialog';
import { useActions, useValues } from 'kea';
import geofencelogic from 'src/store/geofence';
import checkRole from 'src/utils/checkRole';
import profilelogic from 'src/store/profile';
import { Typography } from '@material-ui/core';

const ActionButtons = ({ row }) => {
	const { onMap } = useValues(geofencelogic);
	const { remove, onMapAdd, onMapRemove } = useActions(geofencelogic);
	const { profile } = useValues(profilelogic);
	const handleFocusClick = () => {
		let bounds = new window.google.maps.LatLngBounds();
		row.polygon.coordinates[0].forEach(item => {
			bounds.extend({
				lat: item[1],
				lng: item[0]
			})
		});

		global.gmap.setCenter(bounds.getCenter());
		global.gmap.fitBounds(bounds);
		global.gmap.panToBounds(bounds);
	}

	const handleRemove = () => {
		remove(row);
	}

	const handleHide = () => {
		if (onMap.includes(row._id)) {
			onMapRemove(row._id);
		};
	}

	const handleShow = () => {
		if (!onMap.includes(row._id)) {
			onMapAdd(row._id);
		};
		handleFocusClick();
	}


	return (
		<div id={'rnd-ignore-drag'}>
			{
				onMap.includes(row._id) ?
					<Tooltip title='Hide'>
						<IconButton aria-label="focus" onClick={handleHide}
							size='small'
						>
							<VisibilityOffIcon />
							<Typography>Hide</Typography>
						</IconButton>
					</Tooltip>
					:
					<Tooltip title='Show'>
						<IconButton aria-label="focus" onClick={handleShow}
							size='small'
						>
							<VisibilityIcon />
							<Typography>Show</Typography>
						</IconButton>
					</Tooltip>
			}
			<Tooltip title='Center on map'>
				<IconButton aria-label="focus" onClick={handleFocusClick}
					size='small'
					disabled={!onMap.includes(row._id)}
				>
					<CenterFocusStrongIcon />
					<Typography>Zoom</Typography>
				</IconButton>
			</Tooltip>
			{
				checkRole(profile, ['GeofenceEdit']) &&
				<>
					<SettingsDialog geofence={row} />
					<RemoveDialog OnRemove={handleRemove} />
				</>
			}
		</div>

	);
};

ActionButtons.propTypes = {
	row: PropTypes.object.isRequired
};

export default ActionButtons;
